
import { ChangeDetectionStrategy, Component, computed, inject, OnInit, signal, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RouterService } from '../../core/services/router.service';
import { AuthStore } from '../../core/store/auth/auth.store';
import { CmsService } from '../../core/store/cms/cms.service';
import { CmsStore } from '../../core/store/cms/cms.store';
import { StatusmeldungArticle } from '../../core/store/cms/cms.types';
import { RestUserService } from '../../rest/user.service';
import { ImportantMessageComponent } from '../../shared/building-blocks/important-message/important-message.component';
import { ImportantMessageService } from '../../shared/building-blocks/important-message/important-message.service';
import { KoalButtonComponent } from '../../shared/building-blocks/koal-button/koal-button.component';
import { NavbarComponent } from '../../shared/building-blocks/navbar/navbar.component';

@Component({
  selector:        'app-shell',
  templateUrl:     './shell.component.html',
  imports: [
    RouterModule,
    NavbarComponent,
    KoalButtonComponent,
    ImportantMessageComponent
],
  styleUrls:       ['./shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShellComponent {

  private authStore = inject(AuthStore);
  public routerService = inject(RouterService)
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private importantMessageService = inject(ImportantMessageService)
  cmsStore = inject(CmsStore)

  public currentBackURL: Signal<string> = signal(null);
  public currentUser = this.authStore.currentUser;
  public statusMeldung: StatusmeldungArticle =  this.cmsStore.currentCmsData()?.statusMeldung;
  userService = inject(RestUserService);

  constructor() {
    const onNavigationEnd = toSignal(this.router.events.pipe(filter(event => event instanceof NavigationEnd)));
    this.currentBackURL = computed(() => {
      if (onNavigationEnd()) {
        if (window.history.state?.overrideBackUrl) { // Custom History backUrl has priority
          return window.history.state.overrideBackUrl;
        }
        return this.route.firstChild && this.route.firstChild.snapshot.data ? (this.route.firstChild.snapshot.data as any).backButtonURL : null;
      }
      return null;
    });
    this.importantMessageService.message.next(this.statusMeldung?.acf?.content);
  }

  public logout(): void {
    this.userService.logoutUser();
  }
}
